/**
 * Скрипт масок полей ввода.
 * Добавляет маски в поля ввода через плагин jquery-mask-plugin.
 *
 * @module Mask
 *
 * @see {@link http://igorescobar.github.io/jQuery-Mask-Plugin/}
 *
 * @todo Библиотека имеет зависимость от jQuery, так что стоит подыскать альтернативу.
 */

import 'jquery-mask-plugin';

const initMask = wrapper => {
    $('.js-mask-tel', wrapper).mask('+7(000) 000-00-00');
    $('.js-mask-inn', wrapper).mask('000000000099');
    $('.js-mask-kpp', wrapper).mask('0000AA000');
    $('.js-mask-date-single', wrapper).mask('00.00.0000');
    $('.js-mask-date-range', wrapper).mask('00.00.0000 — 00.00.0000');

    /* Для набора дат маска задаётся в зависимости от ограничения на количество.
    Т.к. регулярное выражение не может быть бесконечным, то по умолчанию ставится ограничение в 10 дат */
    $('.js-mask-date-multiple', wrapper)
        .toArray()
        .forEach(input => {
            const maxCount = $(input)
                .closest('.datepicker')
                .attr('data-max-count');
            $(input).mask(`00.00.0000${', 00.00.0000'.repeat(maxCount ? maxCount - 1 : 10)}`);
        });
};
export default initMask;

$(initMask);
